import React from 'react';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';
import BoschIcon from '@boschebike/ebds-react/dist-esm/components/BoschIcon.js';
import ModalSheet from '@boschebike/ebds-react/dist-esm/components/ModalSheet.js';

const GenericMessageModalSheet = ({ icon, text, color }) => {
  return (
    <ModalSheet.Content type="gooseGenericMessage">
      <Container customContentClassName={['goose-modal-generic-message', color ? `goose-modal-generic-message--${color}` : ''].join(' ')}>
        <span>
          <BoschIcon icon={icon} />
        </span>
        <strong dangerouslySetInnerHTML={{ __html: text }} />
      </Container>
    </ModalSheet.Content>
  );
};

export default GenericMessageModalSheet;
